import {applyContentBlock} from './sourceBlockState';
import type {QuoteBrandingDefault, QuoteContentBlock} from './sourceBlockState';
import type {QuoteTemplate} from '../resolver/types';

/**
 * Seeds a NEW quote from account state: the company's branding default and the default block for
 * each section type.
 *
 * Never called on a revise. The prior published version wins there, so a block edited since that
 * version was published can never rewrite what it said.
 */
export function applyAccountDefaults(
	template: QuoteTemplate,
	branding: QuoteBrandingDefault,
	blocks: readonly QuoteContentBlock[]
): QuoteTemplate {
	const withBranding: QuoteTemplate = {
		...template,
		branding: {
			...template.branding,
			// Either half can be unset; an unset half keeps the built-in rather than blanking it.
			accentColor: branding?.accentColor ?? template.branding.accentColor,
			font: branding?.font ?? template.branding.font,
		},
	};
	return blocks.filter(block => block.isDefault).reduce((current, block) => applyContentBlock(current, block), withBranding);
}
